import React from 'react';
import Modal from 'react-modal';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import s from './LoadingScreenModal.scss';
const LoadingScreenModal = (props)=>{
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: true,
        className: "override",
        overlayClassName: s['reload-overlay']
    }, /*#__PURE__*/ React.createElement(LoadingIndicator, {
        coverMode: true,
        withOverlay: true,
        view: "daSymbol"
    }));
};
LoadingScreenModal.displayName = 'LoadingScreenModal';
export default LoadingScreenModal;

//# sourceMappingURL=LoadingScreenModal.js.map